import i18n from '@/i18n'
import { TIME_FORMATS, DATE_FORMATS } from '@/enum/dateTimeFormats'

export interface TranslatedFormatOption {
    value: string
    label: string
}

export function getTranslatedTimeFormats(): TranslatedFormatOption[] {
    return TIME_FORMATS.map(format => ({
        value: format.value,
        label: (i18n.t(format.label) as string) || format.description
    }))
}

export function getTranslatedDateFormats(): TranslatedFormatOption[] {
    return DATE_FORMATS.map(format => ({
        value: format.value,
        label: (i18n.t(format.label) as string) || format.description
    }))
}
